export enum DepositPaymentDirectionEnum {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
}
